import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

import { mapListEnvelope, mapOrderListItem } from '../_transform';

function getUrl() {
  return 'v4/stock-trading/public/order/ODT/list';
}

/**
 * @typedef   {object}    DtOrderListParams
 * @property  {string}    transactionType
 * @property  {string?}   statusType
 * @property  {number?}   pageSize
 */

/**
 * @typedef {'day'|'sesi'}  OrderPeriod
 */

/**
 * Docs?:
 * TODO: Search Docs
 *
 * @typedef   {object}  OrderDt
 *
 * @property  {unknown[]}   automation_order_item_types
 * @property  {number}      done_order            (Ex: 1)
 * @property  {number}      doneshares_order      (Ex: 0)
 * @property  {string}      executed_time         (Ex: '18:46:05')
 * @property  {number?}     highvolamend          (Ex: 577500)
 * @property  {string}      idx_order_no          (Ex: '202305300000000016')
 * @property  {string}      is_ammend             (Ex: '1' From BE)
 * @property  {string}      is_amend              (Alias from is_ammend)
 * @property  {string}      is_cancel             (Ex: '1')
 * @property  {boolean}     is_forcesell          (Ex: false)
 * @property  {number}      lot_input             (Ex: 1)
 * @property  {unknown}     lowest_ask
 * @property  {number?}     lowvolamend           (Ex: 577500)
 * @property  {string}      market_type           (Ex: '0RG')
 * @property  {string}      message               (Ex: '-')
 * @property  {number}      open_order            (Ex: 0)
 * @property  {number}      openshares_order      (Ex: 100)
 * @property  {string}      order_no              (Ex: '20014')
 * @property  {string}      order_time            (Ex: '2023-05-30T15:58:39.000000')
 * @property  {OrderPeriod} period
 * @property  {number}      price_order           (Ex: 5775)
 * @property  {number}      shares_input          (Ex: 100)
 * @property  {string}      status                (Ex: '0')
 * @property  {string}      status_description    (Ex: 'Open')
 * @property  {string}      stock                 (Ex: 'BBRI')
 * @property  {number}      total_price           (Ex: 577500)
 * @property  {string}      transaction_type      (Ex: '1') -> 1 = Buy
 *
 */

/**
 * @typedef   {object}  OrderListDtPaging
 *
 * @property  {number}    count                 (Ex: 22)
 * @property  {string?}   next
 * @property  {number}    page              (Ex: null)
 * @property  {string?}   previous              (Ex: null)
 * @property  {number}    total_pages
 */

/**
 * @typedef   {object}  OrderListDtResponse
 *
 * @property  {object}              data
 * @property  {string}              data.err_code      (Ex: "EC0000000")
 * @property  {string}              data.err_message   (Ex: "APPROVED/OK")
 * @property  {OrderListDtPaging}   data.paging
 * @property  {OrderDt[]}           data.results
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 *
 * @param {string}            url
 * @param {DtOrderListParams} mtOrderListParam
 * @returns
 */
function callbackFetch(url, { pageSize, statusType, transactionType }) {
  return async ({ pageParam = 1 }) => {
    try {
      /**
       * @type {OrderListDtResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          page: pageParam,
          transaction_type: transactionType,
          status_type: statusType,
          page_size: pageSize,
        },
      });

      return mapListEnvelope(res.data, mapOrderListItem);
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {DtOrderListParams} dtOrderListParams
 * @returns
 */
export default function getV1StockOdtOrderOrderlistfilter(dtOrderListParams = { pageSize: 15 }) {
  const url = getUrl();
  const cb = callbackFetch(url, dtOrderListParams);
  const key = [url, JSON.stringify(dtOrderListParams)];

  return { cb, key };
}
